module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (175).684ffdc9.jpg";